import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../supabaseClient';

const CommonMessageList = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [searchType, setSearchType] = useState('');
  const [searchTitle, setSearchTitle] = useState('');

  const fetchMessages = async (typeFilter, titleFilter) => {
    setLoading(true);
    setErrorMessage('');
    try {
      let query = supabase
        .from('common_message')
        .select('id, type, title, created_at, updated_at')
        .order('id', { ascending: false });

      if (typeFilter) query = query.ilike('type', `%${typeFilter}%`);
      if (titleFilter) query = query.ilike('title', `%${titleFilter}%`);

      const { data, error } = await query;
      if (error) throw error;
      setItems(data ?? []);
    } catch (error) {
      setErrorMessage(error.message || '목록 조회 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMessages('', '');
  }, []);

  const handleSearch = () => {
    fetchMessages(searchType.trim(), searchTitle.trim());
  };

  const handleReset = () => {
    setSearchType('');
    setSearchTitle('');
    fetchMessages('', '');
  };

  const handleDelete = async (item) => {
    if (!window.confirm(`"${item.title}" (${item.type}) 메시지를 삭제할까요?`)) return;
    setLoading(true);
    setErrorMessage('');
    try {
      const { error } = await supabase.from('common_message').delete().eq('id', item.id);
      if (error) throw error;
      await fetchMessages(searchType.trim(), searchTitle.trim());
    } catch (error) {
      setErrorMessage(error.message || '삭제 중 오류가 발생했습니다.');
      setLoading(false);
    }
  };

  return (
    <div className="card shadow mb-4">
      <div className="card-header py-3 d-flex justify-content-between align-items-center">
        <h6 className="m-0 font-weight-bold text-primary">공통 메시지 관리</h6>
        <button
          className="btn btn-primary btn-sm"
          onClick={() => navigate('/common-messages/new')}
          disabled={loading}
        >
          신규 등록
        </button>
      </div>

      <div className="card-body">
        <div className="form-row align-items-end mb-3">
          <div className="form-group col-md-3 mb-2 mb-md-0">
            <label className="small font-weight-bold mb-1">타입</label>
            <input
              type="text"
              className="form-control form-control-sm"
              value={searchType}
              onChange={(event) => setSearchType(event.target.value)}
              placeholder="PRIVACY_COLLECT"
            />
          </div>
          <div className="form-group col-md-3 mb-2 mb-md-0">
            <label className="small font-weight-bold mb-1">제목</label>
            <input
              type="text"
              className="form-control form-control-sm"
              value={searchTitle}
              onChange={(event) => setSearchTitle(event.target.value)}
              placeholder="제목 검색"
            />
          </div>
          <div className="form-group col-md-3 mb-0 d-flex" style={{ gap: 8 }}>
            <button type="button" className="btn btn-primary btn-sm" onClick={handleSearch} disabled={loading}>
              검색
            </button>
            <button type="button" className="btn btn-outline-secondary btn-sm" onClick={handleReset} disabled={loading}>
              초기화
            </button>
          </div>
        </div>

        {errorMessage && (
          <div className="alert alert-danger" role="alert">
            {errorMessage}
          </div>
        )}

        <div className="table-responsive">
          <table className="table table-bordered">
            <thead className="thead-light">
              <tr>
                <th style={{ width: '220px' }}>타입</th>
                <th>제목</th>
                <th style={{ width: '200px' }}>수정일</th>
                <th style={{ width: '160px' }}>액션</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="4" className="text-center">
                    조회 중...
                  </td>
                </tr>
              ) : items.length ? (
                items.map((item) => (
                  <tr key={item.id}>
                    <td>
                      <code>{item.type}</code>
                    </td>
                    <td>{item.title}</td>
                    <td>
                      {item.updated_at || item.created_at
                        ? new Date(item.updated_at || item.created_at).toLocaleString()
                        : '-'}
                    </td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm mr-1"
                        onClick={() => navigate(`/common-messages/${item.id}`)}
                      >
                        수정
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-danger btn-sm"
                        onClick={() => handleDelete(item)}
                        disabled={loading}
                      >
                        삭제
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    조회된 데이터가 없습니다.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CommonMessageList;
